// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesMicroLab = {
  microLabLibraryEntry: "Micro Lab library entry",
  microLabMember: "Micro Lab member",
  microLabRelease: "Micro Lab release",
  microLabRun: "Micro Lab run",
  microLabScheme: "Micro Lab scheme",
  microLabSchemeVersion: "Micro Lab scheme version",
  microLabAuth: "Micro Lab authentication",
  microLabLibrary: "Micro Lab library",
} as const;
